import { WhitelabelRoleEnum } from "@nlc/shared-types";
import { TagIcon } from "lucide-react";

import { Badge } from "@/components/badge";

const ROLE_LABELS: Record<WhitelabelRoleEnum, string> = {
  [WhitelabelRoleEnum.CHILD]: "Whitelabel - Child",
  [WhitelabelRoleEnum.PARENT]: "Whitelabel - Parent",
};

interface WhitelabelBadgeProps {
  className?: string;
  role: null | undefined | WhitelabelRoleEnum;
  size?: "large" | "medium" | "small";
}

export function WhitelabelBadge({
  className,
  role,
  size,
}: WhitelabelBadgeProps) {
  if (!role) return null;

  return (
    <Badge className={className} isRounded size={size} variant="secondary">
      <TagIcon className="mr-1" size={14} />
      {ROLE_LABELS[role]}
    </Badge>
  );
}
